<template>
  <div class="col-xl-3 col-sm-6 mb-xl-0 mb-4">
    <el-card shadow="always" class="c-1" v-loading="loading">
      <div class="row">
        <div class="col-8">
          <div class="numbers">
            <p class="text-sm mb-0 text-uppercase font-weight-bold">{{ title }}</p>
            <h5 class="font-weight-bolder">
              <el-link class="link-dash" v-if="+value > 0 && status !== 'delivered'" type="primary" @click="open(status)">{{ value }}</el-link>
              <span v-else>{{ value }}</span>
            </h5>
          </div>
        </div>
        <div class="col-4 text-end">
          <div :class="'icon icon-shape shadow-primary text-center rounded-circle ' + color">
            <i :class="'ni text-lg opacity-10 ' + icon" aria-hidden="true"></i>
          </div>
        </div>
      </div>
    </el-card>
  </div>
</template>
<script>

import { PrepostService } from "@/services/customers/prepost.services";
import moment from "moment";
import "moment/locale/pt-br";

export default {
  name: "PrepostHomeDashStatusColumn",
  props: ["title", "color", "icon", "startedAt", "finishedAt", "customer", "status", "services"],
  data() {
    return {
      value: 0,
      loading: false,
    }
  },
  methods: {
    open(status) {
      console.log('open dash', status);
      this.$emit("open", status)
    },
    fetch() {
      const vm = this;
      vm.loading = true;
      const s = moment(vm.startedAt);
      const f = moment(vm.finishedAt);
      PrepostService.sro({
        startedAt: s.format("YYYY-MM-DD"),
        finishedAt: f.format("YYYY-MM-DD"),
        customer: vm.customer,
        services: vm.services,
        status: vm.status,
      })
        .then((response) => {
          vm.value = response;
        })
        .catch((error) => {
          this.$message({
            type: "error",
            message: error,
          });
        })
        .finally(() => (vm.loading = false));
    }
  }
}
</script>

<style scoped>
.ni {
  color: #fff;
}
.txt-20 {
  font-size: 20px;
}
.link-dash {
  font-size: 1.25rem;
}
</style>
